/* eslint-disable no-unreachable */
import React from 'react';
import { Tooltip, Input, Button, Row, Col, Select, Radio, Typography,
    Switch, DatePicker, Modal, Spin } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilm, faSave, faCaretDown, faMoneyBillWave, faWater, faCameraRetro, faUpload, faTimes,
    faUserAstronaut, faTrashAlt, faEye, faQuestionCircle } from '@fortawesome/free-solid-svg-icons'
import { dateMonthsString, saveMovieImageApi, imageMovieApi, saveMovieApi, getBase64, imageCensorMovieApi, 
  deleteImageCensorMovieApi, fileUploadApi, stringFormat, localToGMTTime, gmtToLocalTime } from './utils/ApiUtils';
import moment from 'moment';
import Resizer from 'react-image-file-resizer';
import { COLORS } from './utils/Constants';

const Entities = require('html-entities').AllHtmlEntities;
const entities = new Entities();
const { Option } = Select;
const { TextArea } = Input;
const { Text } = Typography;
const dateTimeFormat = "DD-MMM-YYYY HH:mm";

let uploadHintStyle = { color: COLORS.greyaaa, fontSize: 12, marginBottom: 0 };
let inputStyle = { width: '75%', color: COLORS.blue3a4a5a, fontSize: 14, fontFamily: 'OpenSans-Bold' };
let textStyle = { fontSize: 14, fontFamily: 'OpenSans-Bold', textAlign:'left', marginBottom: 0, color: COLORS.cccWhite, marginLeft: 8 };

let supportEmail = "Support Email: hello@hit.movie";
let movieNameTip = "This is the name end users see.";
let languageTooltip = "Select the primary language of your movie."
let genre = "Select one or more appropriate genres."
let summaryTooltip = "A brief summary of what your movie is about. Make sure you do not reveal any spoilers."
let distribution = "Select all the countries where you wish to sell your movie. Default is World Wide."
let exDistribution = "Select all the countries where you do not wish to sell your movie."
let identityTooltip = "Select who can buy and watch your movie. Click help to know more.";
let viewTimeStr = "The number of days for which a ticket buyer can watch your movie. Default is 2 Days."
let viewTimeHoursStr = "The number of hours for which a ticket buyer can watch your movie. Default is 5 hours.";
let releaseDateString = "The date, time and timezone when you want to release your movie. Timezone is usually where your primary audience are located (Ex: IST for India)."
let preBooking = "Pre Booking allows you to sell tickets up to 7 days in advance of a movie release. Your full movie files and all related content and details must be submitted to Hit.Movie for you to accept Pre Bookings. All Pre Bookings are subject to a manual review and approval by Hit.Movie. You will not be allowed to de-list or delete your movie once you start accepting Pre Bookings."
let ratingTooltip = "0+ Suitable for all ages  --- 7+ Suitable for children over 7 years --- 13+ Suitable for children over 13 years --- 18+ Prohibited for children under 18 years";
let censor = "Upload Censor Certificate (for Indian Movies only).";
let ticketPrice = "Local Price is displayed to ticket buyers in your legal jurisdiction (Ex: INR for India). Minimum is INR 150 for India. Rest of World Price is displayed to ticket buyers in all countries other than your legal jurisdiction. Minimum is USD 4.99. Ticket prices must be INCLUSIVE OF TAXES. So please markup your price accordingly. Producers make 70% of ticket revenue after taxes.";
let warningText1 = "Please complete the above section to activate below sections.";
let warningText2 = "Please complete ALL the above sections and upload your Movie/Trailer files.\nThe below section will be activated once we verify all your files. This can take up to 7 days.\nYou will receive an email once the verification process is complete.";
let warningText3 = "Test your Movie and Trailer by clicking the above buttons.\nIf you are satisfied go ahead and fill in ALL the details below.\nPre-Bookings can be enabled only upto 7 days prior to your movie release date.\nRelease date CANNOT be changed once Pre Booking is enabled and saved.\nClick 'Save' after you fill in ALL the details to release/schedule your movie.";
let verifyIdText = "Accept verified identity users only."

const resizeFile = (file, quality, maxWidth, maxHeight) => new Promise(resolve => {
  Resizer.imageFileResizer(file, maxWidth, maxHeight, 'JPEG', quality, 0,
  uri => {
    resolve(uri);
  },
  'blob'
  );
});

function disabledDate(current) {
  // Can not select days before today and today
  return current && current < moment().startOf('day');
}
const suffix2 = (
  <Text
    style={{
      fontSize: 14,
      color: COLORS.greyaaa,
      backgroundColor: COLORS.eeeWhite,
      padding: 4,
      paddingLeft: 8,
      paddingRight: 8,
      borderRadius: 5,
    }}
  >USD</Text>
);

export default class MovieForm extends React.Component {
  state = {
    movieName: '', language: null, timezone: null, rating: '', viewTime: 2, modalImage: '',
    releaseDate: null, save1: false, save2: false, save3: false, censorImage: '', movieViewTimeHours: 5,
    saving1: false, saving2: false, saving3: false, errorText: '', censorName: '', disableWarnig: false,
  };
  componentDidMount() {
    let sessionValue = localStorage.getItem('localStorageSession') || '';
    console.log('sessionValue='+sessionValue+' uploadId='+this.props.uploadId);
    if(sessionValue) {
      this.setState({ sessionValue: sessionValue });
    }
    let userObj = localStorage.getItem('userObj') || '';
    if(userObj) {
      userObj = JSON.parse(userObj);
      this.setState({ userObj: userObj });
    }  
    this.inputElement = '';
    this.inputElement1 = '';
    this.inputElement2 = '';
  }
  componentDidUpdate() {
    let addMovieObj = this.props.addMovieObj;
    let extraInfo = this.props.extraInfo;
    console.log('moveForm='+this.props.uploadId+' addMovieObj='+(addMovieObj));
    if(addMovieObj&&(this.state.uploadId!==addMovieObj.id||addMovieObj.username!=this.state.username)) {
      let movieObj = addMovieObj.movie;
      let { banner_thumbnail, banner, portrait, portrait_thumbnail } = movieObj.mediaLinks;
      this.setState({ uploadId: addMovieObj.id, movieName: movieObj.movieName, language: movieObj.language ? movieObj.language : null, 
        genres: [], rating: movieObj.rating, summary: movieObj.summary, viewTime: addMovieObj.movieViewTime ? addMovieObj.movieViewTime : 2,
        countries: [], excludedCountries: [], priceINR: addMovieObj.moviePriceList&&addMovieObj.moviePriceList[0] ? addMovieObj.moviePriceList[0].price : null,
        priceUSD: addMovieObj.moviePriceList&&addMovieObj.moviePriceList[1] ? addMovieObj.moviePriceList[1].price : null, deleteIndex: 0,
        verifyIdentity: addMovieObj.verifyIdentity, movieViewTimeHours: addMovieObj.movieViewTimeHours ? addMovieObj.movieViewTimeHours : 5,
        prebooking: addMovieObj.acceptPrebookings, acceptPrebookings: addMovieObj.acceptPrebookings, directors: movieObj.directors, writers: movieObj.writers,
        stars: movieObj.stars, producers: movieObj.producers, productionhouse: movieObj.productionHouse, username: addMovieObj.username,
        censorImage: movieObj.censorMediaLinks&&movieObj.censorMediaLinks.CENSOR ? movieObj.censorMediaLinks.CENSOR : '', 
        uploadLink: extraInfo.requestLink, bannerImage: banner_thumbnail ? banner_thumbnail : banner, portraitImage: portrait_thumbnail ? portrait_thumbnail : portrait, 
        localCurrency: addMovieObj.localCurrency, legalEntityCountry: addMovieObj.legalEntityCountry,
        localCharge: addMovieObj.minimalLocalCharge ? addMovieObj.minimalLocalCharge : '', enableBuyWatchnow: addMovieObj.enableBuyWatchnow,
        restWorldCharge: addMovieObj.minimalNonLocalCharge ? addMovieObj.minimalNonLocalCharge : '', save1: false, save2: false, save3: false,
        azureTrailerLocatorName: addMovieObj.azureTrailerLocatorName, azureStreamingLocatorName: addMovieObj.azureStreamingLocatorName,
        timezone: addMovieObj.movieTimezone ? addMovieObj.movieTimezone : null, censorName: addMovieObj.censorCertificateName });
        let countryArr = addMovieObj.countries;
        if(countryArr) {
            countryArr = countryArr.split(',');
            this.setState({ countries: countryArr });
        }
        let exCountryArr = addMovieObj.excludedCountries;
        if(exCountryArr) {
          exCountryArr = exCountryArr.split(',');
            this.setState({ excludedCountries: exCountryArr });
        }
        if(addMovieObj.movieReleaseTime) {
          let movieTime = gmtToLocalTime(addMovieObj.movieReleaseTime*1000);
          console.log('new moveTime='+movieTime);
          let releaseDate = movieTime;
          this.setState({ releaseDate: releaseDate });
        } else if(addMovieObj.movieReleaseDate) {
          let releaseDate = addMovieObj.movieReleaseDate*1000;
          this.setState({ releaseDate: releaseDate });
        } else {
          this.setState({ releaseDate: null });
        }
        let genreArr = movieObj.genre;
        if(genreArr) {
            genreArr = genreArr.split(',');
            this.setState({ genres: genreArr });
        } else {
          this.setState({ genres: [] });
        }
        if(!(movieObj.language&&genreArr&&movieObj.summary&&movieObj.rating)) {
          this.setState({ disableWarnig: true });
        } else {
          this.setState({ disableWarnig: false });
        }
    } 
  }
  suffix1 = (localPrice) => {
    return (
      <Text style={{fontSize: 14, color: COLORS.greyaaa, backgroundColor: COLORS.eeeWhite, padding: 4, paddingLeft: 8, paddingRight: 8, borderRadius: 5 }}>
        {localPrice}
      </Text>
    );
  }
  saveMovie1 = (disableForm, saveEnabled) => {
    if(disableForm||(!saveEnabled)) {
      return;
    }
    this.setState({ saving1: true });
    let movieName = this.state.movieName;
    let censorCertificateName = this.state.censorName;
    let language = this.state.language;
    let genres = this.state.genres;
    console.log('genres='+genres);
    let genre = '';
    if(genres&&genres.length>0) {
      if(genres.length===1) {
        genre = genres[0];
      } else {
        genres.map((item, index) => {
          genre += item+', ';
        });
        genre = genre.substring(0, genre.length - 2);
      }
    }
    let summary = this.state.summary;
    let rating = this.state.rating;
    let censorFile = this.state.censorFile;
    if(!movieName) {
      alert('Movie name cannot be empty!');
      return;
    }
    let tempObj = { moviename: movieName };
    if(language) { tempObj['language'] = language };
    if(censorCertificateName) { tempObj['censorCertificateName'] = censorCertificateName };
    if(genre) { tempObj['genre'] = genre };
    if(summary) { tempObj['summary'] = summary };
    if(rating) { tempObj['rating'] = rating };
    if(censorFile) {
      tempObj['censorFilenames'] = [{ 'type': 'CENSOR', 'filename': censorFile }];
    }
    this.saveMovie(tempObj, 1);
  }
  saveMovie2 = (disableForm, saveEnabled) => {
    if(disableForm||(!saveEnabled)) {
      return;
    }
    this.setState({ saving2: true });
    let directors = this.state.directors;
    let writers = this.state.writers;
    let stars = this.state.stars;
    let producers = this.state.producers;
    let productionhouse = this.state.productionhouse;
    let tempObj = { };
    if(directors) { tempObj['directors'] = directors };
    if(writers) { tempObj['writers'] = writers };
    if(stars) { tempObj['stars'] = stars };
    if(producers) { tempObj['producers'] = producers };
    if(productionhouse) { tempObj['productionhouse'] = productionhouse };
    this.saveMovie(tempObj, 2);
  }
  saveMovie3 = (disableForm, saveEnabled) => {
    if(disableForm||(!saveEnabled)) {
      return;
    }
    this.setState({ saving3: true });
    let countryArr = this.state.countries;
    let exCountryArr = this.state.excludedCountries;
    let { viewTime, timezone, prebooking, verifyIdentity, movieViewTimeHours } = this.state;
    let tempObj = { };
    let priceArray = [];
    if(this.state.priceINR) {
      let currency = this.state.localCurrency;
      let country = this.state.legalEntityCountry;
      let precisionPrice = this.state.priceINR+'';
      if(precisionPrice.includes('.')) {
        precisionPrice = parseFloat(precisionPrice).toFixed(2);
      }
      this.setState({ priceINR: precisionPrice });
      priceArray.push({ "ticketPrice" : precisionPrice, "ticketCurrency" : currency, "country" : country });
    }
    if(this.state.priceUSD) {
      let precisionPrice = this.state.priceUSD+'';
      if(precisionPrice.includes('.')) {
        precisionPrice = parseFloat(precisionPrice).toFixed(2);
      }
      this.setState({ priceUSD: precisionPrice });
      priceArray.push({ "ticketPrice" : precisionPrice, "ticketCurrency" : 'USD', "country" : 'Rest of the world' });
    }
    if(countryArr) { tempObj['countries'] = countryArr };
    if(exCountryArr) { tempObj['excludedCountries'] = exCountryArr };
    if(viewTime) { tempObj['movieViewTime'] = viewTime };
    if(movieViewTimeHours) { tempObj['movieViewTimeHours'] = movieViewTimeHours };
    if(priceArray) { tempObj['price'] = priceArray };
    let preBookingButton = this.state.acceptPrebookings;
    let releaseDate = this.state.releaseDate;
    if(releaseDate&&(releaseDate>Date.now())&&(!preBookingButton)) {
      if(prebooking) { tempObj['prebooking'] = prebooking };
      if(timezone) { tempObj['timezone'] = timezone };
      let utcTime = localToGMTTime(releaseDate);
      tempObj['movieReleaseDate'] = parseInt(utcTime/1000);
      tempObj['movieReleaseTime'] = parseInt(utcTime/1000);
    }
    tempObj['verifyIdentity'] = verifyIdentity;
    this.saveMovie(tempObj, 3);
  }
  saveMovie = (tempObj, index) => {    
    let uploadId = this.props.addMovieObj.id;
    let sessionValue = this.state.sessionValue;
    console.log('sessionValue='+sessionValue+' uploadId='+uploadId);
    tempObj['uploadId'] = uploadId;
    let censorFile = this.state.censorFile;
    console.log('save movie tempObj='+JSON.stringify(tempObj));
    saveMovieApi(sessionValue, tempObj)
    .then(response => {
      console.log('save movie data='+JSON.stringify(response));
      if(response.ok) {
        let movieObj = response.info.movieInfo;
        if(censorFile) {
          this.uploadMediaFiles2(sessionValue, uploadId, movieObj.movie, censorFile);
        } else {
          this.setState({ save1: false, save2: false, save3: false, saving1: false, saving2: false, saving3: false });
        }
        if(response.info.requestLink) {
          this.setState({ uploadLink: response.info.requestLink });
          if(this.state.prebooking) {
            this.setState({ acceptPrebookings: true });
          }
        }
        if(index===1) {
          if(!(tempObj.language&&tempObj.genre&&tempObj.summary&&tempObj.rating)) {
            this.setState({ disableWarnig: true });
          } else {
            this.setState({ disableWarnig: false });
          }
        } else if(index===3) {
          this.setState({ errorText: '' });
        }
        this.props.refreshMoveList();
      } else {
        console.log('Save movie failed!');
        if(index===3) {
          this.setState({ errorText: response.info ? (response.info.response ? response.info.response : response.info) : 'Api failed. Please try again.' });
        } else {
          alert(response.info);
        }
        this.setState({ saving1: false, saving2: false, saving3: false });
      }
    })
    .catch((error) => {
      console.log('Error saving movie data='+JSON.stringify(error));
      this.setState({ saving1: false, saving2: false, saving3: false });
    });
  }
  uploadMediaFiles2 = (sessionValue, uploadId, movieObj, censorFile) => {
    let censorUrl = movieObj.putCensorMediaLinks.CENSOR;
    console.log('censor='+censorUrl+' uploadId='+uploadId);
    if(censorUrl) {
      fileUploadApi(sessionValue, censorUrl, this.state.censorDoc)
      .then(response => {
        this.setState({ save1: false, save2: false, save3: false, saving1: false, saving2: false, saving3: false });
        console.log('Update business data='+JSON.stringify(response));
        if(response) {
          imageCensorMovieApi(sessionValue, uploadId, movieObj.id, 'save_db', 'CENSOR', censorFile).then(response => {
            console.log('image update data='+JSON.stringify(response));
          });
        } else {
          console.log('PAN Upload failed!');
          alert('PAN Upload Failed!');
        }
      })
      .catch((error) => {
        this.setState({ save1: false, save2: false, save3: false, saving1: false, saving2: false, saving3: false });
        console.log('Error Business Update data='+JSON.stringify(error));
      });
    } else {
      this.setState({ save1: false, save2: false, save3: false, saving1: false, saving2: false, saving3: false });
    }
  }
  uploadImageApi = () => {
    let sessionValue = this.state.sessionValue;
    console.log('sessionValue='+sessionValue+' uploadId='+this.state.uploadId);
    let uploadId = this.state.uploadId;
    let bannerFile = this.state.bannerFile;
    let portraitFile = this.state.portraitFile;
    let mediaFilenames = {  };
    if(bannerFile) {
      mediaFilenames['banner'] = bannerFile;
      mediaFilenames['banner_thumbnail'] = bannerFile;
    }
    if(portraitFile) {
      mediaFilenames['portrait'] = portraitFile;
      mediaFilenames['portrait_thumbnail'] = portraitFile;
    }
    if(bannerFile||portraitFile) {
      saveMovieImageApi(sessionValue, uploadId, mediaFilenames)
      .then(response => {
        console.log('Add initial data='+JSON.stringify(response.info));
        if(response.ok) {
          // this.props.updateMovieObj(response.info);
          this.uploadMediaFiles(sessionValue, uploadId, response.info.movieInfo.movie, bannerFile, portraitFile);
        } else {
          console.log('Add Initial Data failed!');
        }
      })
      .catch((error) => {
        console.log('Error Adding Initial data='+JSON.stringify(error));
      });
    }
  }
  uploadMediaFiles = (sessionValue, uploadId, movieObj, bannerFile, portraitFile) => {
    let portraitUrl = movieObj.putMediaLinks.portrait;
    let bannerUrl = movieObj.putMediaLinks.banner;
    console.log('portraitUrl='+portraitUrl+' uploadId='+uploadId+' bannerUrl='+bannerUrl);
    if(bannerUrl&&bannerFile) {
      fileUploadApi(sessionValue, bannerUrl, this.state.bannerDoc)
      .then(response => {
        console.log('Update business data='+JSON.stringify(response));
        if(response) {
          imageMovieApi(sessionValue, movieObj.id, 'save_db', 'banner', 'image', bannerFile).then(response => {
            console.log('image update data='+JSON.stringify(response));
          });
        } else {
          console.log('PAN Upload failed!');
          alert('PAN Upload Failed!');
        }
      })
      .catch((error) => {
        console.log('Error Business Update data='+JSON.stringify(error));
      });
      let bannerThumbnailUrl = movieObj.putMediaLinks.banner_thumbnail;
      let maxWidth = 3000, maxHeight = 1000;
      this.uploadThumbnail(sessionValue, movieObj.id, bannerThumbnailUrl, this.state.bannerDoc, bannerFile, maxWidth, maxHeight, 'banner_thumbnail');
    }
    if(portraitUrl&&portraitFile) {
      fileUploadApi(sessionValue, portraitUrl, this.state.portraitDoc)
      .then(response => {
        console.log('Update business data='+JSON.stringify(response));
        if(response) {
          imageMovieApi(sessionValue, movieObj.id, 'save_db', 'portrait', 'image', portraitFile).then(response => {
            console.log('image update data='+JSON.stringify(response));
          });
        } else {
          console.log('PAN Upload failed!');
          alert('PAN Upload Failed!');
        }
      })
      .catch((error) => {
        console.log('Error Business Update data='+JSON.stringify(error));
      });
      let portraitThumbnailUrl = movieObj.putMediaLinks.portrait_thumbnail;
      let maxWidth = 1500, maxHeight = 900;
      this.uploadThumbnail(sessionValue, movieObj.id, portraitThumbnailUrl, this.state.portraitDoc, portraitFile, maxWidth, maxHeight, 'portrait_thumbnail');
    }
  }
  uploadThumbnail = async(sessionValue, movieId, url, file, fileName, maxWidth, maxHeight, fileType) => {
    let quality = 100;
    let image = await resizeFile(file, quality, maxWidth, maxHeight);
    console.log('image size='+image.size);
    if(image&&image.size) {
      while(image.size>100000) {
        quality = quality - 10;
        image = await resizeFile(file, quality, maxWidth, maxHeight);
        console.log('image size='+image.size);
      }
      fileUploadApi(sessionValue, url, image)
        .then(response => {
          console.log('Update business data='+JSON.stringify(response));
          if(response) {
            imageMovieApi(sessionValue, movieId, 'save_db', fileType, 'image', fileName).then(response => {
              console.log('image update data='+JSON.stringify(response));
            });
          } else {
            console.log('image Upload failed!');
          }
        })
        .catch((error) => {
          console.log('Error Business Update data='+JSON.stringify(error));
        });
    }
  }
  handleNameChange = (e) => {
    let value = e.target.value;
    this.setState({ movieName: value, save1: true });
  }
  handleCensorName = (e) => {
    let value = e.target.value;
    this.setState({ censorName: value, save1: true });
  }
  setLanguage = (e) => {
    this.setState({ language: e, save1: true });
  }
  setTimeZone = (e) => {
    console.log('timezone='+e)
    this.setState({ timezone: e, save3: true });
  }
  setGenre = (e) => {
    console.log('genres='+e);
    this.setState({ genres: e, save1: true });
  }
  handleCountries = (e) => {
    console.log('countries='+e);
    if(e.indexOf('Worldwide') !== -1) {
      this.setState({ countries: ['Worldwide'], save3: true });
    } else {
      this.setState({ countries: e, excludedCountries: [], save3: true });
    }
  }
  handleExcludeCountries = (e) => {    
    console.log('excludedCountries='+e);
    this.setState({ excludedCountries: e, save3: true });
  }
  handleSummary = (e) => {
    let value = e.target.value;
    console.log('summary='+value);
    this.setState({ summary: value, save1: true });
  }
  handleViewTime = (e) => {
      console.log('hi');
    let value = e.target.value;
    console.log('viewTime='+value);
    this.setState({ viewTime: value, save3: true });
  }
  handleViewTimeHours = (e) => {
    let value = e.target.value;
    console.log('viewTimeHours='+value);
    this.setState({ movieViewTimeHours: value, save3: true });
  }
  handleRating = (e) => {
    let value = e.target.value;
    console.log('summary='+value);
    this.setState({ rating: value, save1: true });
  }
  handlePriceUSD = (e) => {
    let value = e.target.value;
    console.log('priceUSD='+value);
    this.setState({ priceUSD: value, save3: true });
  }
  handlePriceINR = (e) => {
    let value = e.target.value;
    console.log('priceINR='+value);
    this.setState({ priceINR: value, save3: true });
  }
  handleDirector = (e) => {
    let value = e.target.value;
    this.setState({ directors: value, save2: true });
  }
  handleProducer = (e) => {
    let value = e.target.value;
    this.setState({ producers: value, save2: true });
  }
  handleProductionHouse = (e) => {
    let value = e.target.value;
    this.setState({ productionhouse: value, save2: true });
  }
  handleStars = (e) => {
    let value = e.target.value;
    this.setState({ stars: value, save2: true });
  }
  handleWriter = (e) => {
    let value = e.target.value;
    this.setState({ writers: value, save2: true });
  }
  onChangeIdentitySwitch = (e) => {
    console.log('value='+e.target.value);
    this.setState({ verifyIdentity: e.target.value=='Everyone' ? false : true, save3: true });
  }
  onChangeSwitch = (checked) => {
    console.log('checked='+checked);
    let releaseDate = this.state.releaseDate;
    let timezone = this.state.timezone;
    if(releaseDate&&timezone) {
      if(Date.now()+604800000<releaseDate) {
        let prebookDate = dateMonthsString(releaseDate-604800000);
        this.setState({ errorText: 'Pre-Bookings can be enabled only upto 7 days prior to your movie release date. \nBased on your current release date, you can enable Pre-Bookings on '+prebookDate+'.' });
      } else {
        if(checked) {
          this.setState({ prebooking: checked, save3: true, errorText: 'Release date CANNOT be changed once Pre Booking is enabled and saved.' });
        } else {
          this.setState({ prebooking: checked, save3: true, errorText: '' });
        }
      }
    } else {
      this.setState({ errorText: 'You cannot enable Pre-Booking without a Release Date, Time & Timezone.' });
    }
  }
  onDateChange = (date, dateString) => {
    console.log('date='+date+' string='+dateString);
    this.setState({ releaseDate: date, save3: true });
  }
  addImageProcess(src){
    return new Promise((resolve, reject) => {
      let img = new Image()
      img.onload = () => { 
          let obj = { height: img.height, width: img.width };
          resolve(obj);
       }
      img.onerror = reject
      img.src = src
    })
  }
  onDocUpload = (event, index) => {
    let file = event.target.files[0];
    console.log('file='+JSON.stringify(file ? file.size : file));
    try {
      if(file) {
        getBase64(file, imageUrl => {
          let objectURL = null;
          if(file.type==='application/pdf') {
            var blob = new Blob([file], { type: "application/pdf" });
            objectURL = window.URL.createObjectURL(blob);
          }
          if(index===1) {
              if(file.size>3000000) {
                  this.setState({ bannerError: true });
                  return;
              }
              this.addImageProcess(imageUrl).then((obj) => {
                  console.log('obj='+JSON.stringify(obj));
                  if((obj.width/obj.height!==3)||(obj.width<3000)) {
                      this.setState({ bannerError: true });
                  } else {
                      this.setState({ bannerImage: imageUrl, bannerFile: file.name, bannerDoc: file });
                      this.uploadImageApi();
                  }
              });
          } 
          if(index===2) {
              if(file.size>3000000) {
                  this.setState({ portraitError: true });
                  return;
              }
              this.addImageProcess(imageUrl).then((obj) => {
                  console.log('obj='+JSON.stringify(obj));
                  if((obj.width*3/obj.height!==5)||(obj.width<1500)) {
                      this.setState({ portraitError: true });
                  } else {
                      this.setState({ portraitImage: imageUrl, portraitFile: file.name, portraitDoc: file }); 
                      this.uploadImageApi();       
                  }
              });       
          } 
          if(index===3) {
              this.setState({ censorImage: imageUrl, censorFile: file.name, censorDoc: file, censorUrl: objectURL, save1: true });
          }        
        });
      }
    } catch(e) {
      console.log('error');
      if(index===1) {
        this.setState({ bannerError: true });
      } else if(index===2) {
        this.setState({ portraitError: true });
      }
    }
  };
  deleteImage = (index) => {
    // alert('Error in delete api!')
    let addMovieObj = this.props.addMovieObj;
    let uploadId = addMovieObj.id;
    let movieId = addMovieObj.movie.id;
    let sessionValue = this.state.sessionValue;
    if(this.state.deleteIndex===1) {
      deleteImageCensorMovieApi(sessionValue, uploadId, movieId, 'remove_db', 'CENSOR').then(response => {
        console.log('image delete data='+JSON.stringify(response));
        if(response.ok) {
          this.setState({ censorImage: '', deleteIndex: 0 });
        } else {
          this.setState({ deleteIndex: 0 });
        }
      });
    } else {
        this.setState({ deleteIndex: 1 });
    }   
  }
  showModal = (image, pdfUrl) => {
    this.setState({ modalImage: image, pdfUrl: pdfUrl });
  }
  handleCancel = () => {
    this.setState({ modalImage: '', pdfUrl: '' });
  }
  suffixDoc = (index) => {
    let imageUrl = this.state.censorImage;
    let text = "Upload Censor";
    return (
      imageUrl
        ?
        <div style={{ display: 'flex' }}>
          <div onClick={() => { this.showModal(imageUrl, this.state.censorUrl) }} style={{ cursor: 'pointer', display: 'flex', justifyContent:'center', alignContent:'center' }}>
            <FontAwesomeIcon color={COLORS.yellow} icon={faEye} style={{ fontSize: 24, alignSelf: 'center' }} />
          </div>
          <div onClick={() => { this.deleteImage(index) }} style={{ cursor: 'pointer', display: 'flex', justifyContent:'center', alignContent:'center', marginLeft: 8 }}>
            <FontAwesomeIcon color={COLORS.redClose} icon={faTrashAlt} style={{ fontSize: 24, alignSelf: 'center' }} />
          </div>
        </div>
        :
        <div>
          <Text onClick={() => { this.props.disableForm ? console.log('disabled form') : this.inputElement.click() }} style={{ cursor:'pointer', fontSize: 14, color: COLORS.greyaaa, backgroundColor: COLORS.eeeWhite, padding: 4, paddingLeft: 8, paddingRight: 8, borderRadius: 5 }}>
            {text}
          </Text>
          <input style={{ display:'none' }} type="file" ref={input => this.inputElement = input} onChange={(e) => { this.onDocUpload(e, 3) }} />   
        </div>
    );
  }
  openDropBox = (disableForm) => {
    if(disableForm) {
      console.log('for disabled');
    } else if(this.state.uploadLink) {
      window.open(this.state.uploadLink, "_blank");
    }
  }
  render() {
    let languages = this.props.languages;
    let timezones = this.props.timezones;
    let genresList = this.props.genres;
    let countries = this.props.countries;
    let notWorldWide = false;
    let currentCountryList = this.state.countries;
    if(currentCountryList) {
      notWorldWide = currentCountryList.indexOf('Worldwide') === -1;
    }
    let exceptionCountries = countries ? countries.slice(1, countries.length) : [];
    // console.log('add movie props='+languages);
    let listingWidth = window.innerWidth/30;
    console.log('this.state.uploadLink='+this.state.uploadLink+' width='+listingWidth);
    let bannerHeight = (window.innerWidth*14)/72;
    let disableForm = this.props.disableForm;
    let save1Color = COLORS.white;
    let save1Enabled = this.state.save1;
    let save2Enabled = this.state.save2;
    let save3Enabled = this.state.save3;
    let save1BG = save1Enabled ? COLORS.red : COLORS.yellowLight;
    let save2BG = save2Enabled ? COLORS.red : COLORS.yellowLight;
    let save3BG = save3Enabled ? COLORS.red : COLORS.yellowLight;
    let opacity1 = save1Enabled ? 1 : 0.5;
    let opacity2 = save2Enabled ? 1 : 0.5;
    let opacity3 = save3Enabled ? 1 : 0.5;
    let localCharge = '', worldCharge = '';
    let enableBuyWatchnow = this.state.enableBuyWatchnow;
    if(this.state.localCharge) {
      let chargeValue = this.state.verifyIdentity ? this.state.localCharge.idVerified : this.state.localCharge.nonIdVerified;
      localCharge = '(Min '+chargeValue+')';
    }
    if(this.state.restWorldCharge) {
      let chargeValue = this.state.verifyIdentity ? this.state.restWorldCharge.idVerified : this.state.restWorldCharge.nonIdVerified;
      worldCharge = '(Min '+chargeValue+')';
    }
    let localCurrency = this.state.localCurrency;
    if(!localCurrency) {
      let userObj = this.state.userObj;
      if(userObj) {
        localCurrency = userObj.location ? userObj.location.currency : 'USD';
      } else {
        localCurrency = 'USD';
      }
    }
    let { summary, movieName, censorName, directors, writers, stars, producers, productionhouse, timezone } = this.state;
    if(summary) {
      summary = stringFormat(summary, entities);
    }
    if(movieName) {
      movieName = stringFormat(movieName, entities);
    }
    if(censorName) {
      censorName = stringFormat(censorName, entities);
    }
    if(directors) {
      directors = stringFormat(directors, entities);
    }
    if(writers) {
      writers = stringFormat(writers, entities);
    }
    if(stars) {
      stars = stringFormat(stars, entities);
    }
    if(producers) {
      producers = stringFormat(producers, entities);
    }
    if(productionhouse) {
      productionhouse = stringFormat(productionhouse, entities);
    }
    if(timezone) {
      timezone = stringFormat(timezone, entities);
    }
    let disableForm1 = disableForm;
    let disableForm2 = disableForm;
    let disableWarnig = this.state.disableWarnig;
    disableForm2 = disableForm2 || disableWarnig;
    let azureStreamingLocatorName = this.state.azureStreamingLocatorName;
    let disableForm3 = azureStreamingLocatorName ? false : true;
    let isReleaseDisabled = this.state.prebooking||disableForm3;
    let isPrebookingDisabled = this.state.acceptPrebookings||disableForm3;
    if(this.state.releaseDate&&(this.state.releaseDate<Date.now())) {
      isReleaseDisabled = true;
      isPrebookingDisabled = true;
    }
    let isIndia = this.state.legalEntityCountry==='India';
    let documentUrl = this.state.modalImage&&this.state.modalImage.includes('.pdf') ? this.state.modalImage : this.state.pdfUrl;
    console.log('sessionValue='+this.state.sessionValue+' uploadId='+this.state.uploadId+' disableForm2='+disableForm2);
    return (
        <div>
            <Modal
                closable={true}
                closeIcon={<FontAwesomeIcon className='modalCloseIcon'icon={faTimes} />}
                bodyStyle={{ padding: 0 }}
                centered={true}
                footer={null}
                visible={this.state.modalImage}
                onOk={this.handleOk}
                onCancel={this.handleCancel}
                >
                <div style={{ display: 'flex', justifyContent:'center', alignContent: 'center' }}>
                  { documentUrl
                  ?
                  <object data={documentUrl} type="application/pdf" width={window.innerWidth-100} height={window.innerHeight-100}>
                    <a href={documentUrl}>test.pdf</a>
                  </object>
                  :
                  <img src={this.state.modalImage} alt="your pic" style={{ maxHeight: window.innerHeight-100, maxWidth: window.innerWidth-100 }} />
                  } 
                </div>
            </Modal>
            <div style={{ border: '2px solid #1a2a3a' }}>
              <div style={{ display: 'flex', flex:1, height: 54, backgroundColor: COLORS.yellow, borderBottom: '2px solid #1a2a3a' }}>
                <div style={{ display: "flex", justifyContent:'center', alignItems: "center", width: '100%', height:'100%' }}>
                  <FontAwesomeIcon color={COLORS.darkBlue} icon={faFilm} style={{ fontSize: 24, margin: '12px' }} />
                  <h2 style={{ fontSize: 18, fontFamily: 'OpenSans-Bold', alignSelf:'center', textAlign:'center', color: COLORS.darkBlue, marginBottom: 0 }}>Movie Details</h2>
                  <FontAwesomeIcon color={COLORS.darkBlue} icon={faFilm} style={{ fontSize: 24, margin: '12px' }} />                  
                </div>   
                <Button onClick={() => { this.saveMovie1(disableForm, save1Enabled) }} className='caption' style={{ position:'absolute', display: "flex", alignItems: "center", 
                justifyContent:'center', right: 0, width: 100, height: 32, backgroundColor: save1BG, borderRadius: 3, margin: 10, opacity: opacity1 }}>
                  <div style={{ display: "flex", alignItems: "center", justifyContent:'center' }}>
                    { this.state.saving1
                    ?
                    <Spin size='small' style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginRight: 12 }} />
                    :
                    <FontAwesomeIcon color={COLORS.darkBlue} icon={faSave} style={{ color: save1Color, fontSize: 14, marginRight: 12 }} />
                    }
                    <h4 style={{ display: "flex", alignItems: "center", color: save1Color, fontSize: 14, height:'100%', margin:0, fontFamily: 'OpenSans-Bold' }}>
                      Save
                    </h4>
                  </div>
                </Button>             
              </div>
              <Tooltip placement='left' trigger='hover' title={movieNameTip}>
              <div style={{ display: 'flex', flex:1, height: 54, backgroundColor: COLORS.blue2a3a4a, border: '1px solid #1a2a3a', borderTopWidth: 0 }}>
                <div style={{ display: "flex", alignItems: "center", width: '25%', height:'100%' }}>
                  <h3 style={textStyle}>Movie Name</h3>
                </div>
                <Input disabled={disableForm1} placeholder="Movie Name" style={inputStyle} value={movieName} 
                  className='bankInput' onChange={(e) => { this.handleNameChange(e) }} />
              </div>
              </Tooltip>
              <Tooltip placement='left' trigger='hover' title={languageTooltip}>
              <div style={{ display: 'flex', flex:1, height: 54, backgroundColor: COLORS.blue2a3a4a, border: '1px solid #1a2a3a', borderTopWidth: 0 }}>
                <div style={{ display: "flex", alignItems: "center", width: '25%', height:'100%' }}>
                  <h3 style={textStyle}>Language</h3>
                </div>
                <Select className='customDropdown' disabled={disableForm1} placeholder='Language' value={this.state.language}
                style={{ flex:1, height: 54 }} onChange={(val)=>{ this.setLanguage(val) }}
                suffixIcon={<FontAwesomeIcon color={COLORS.yellow} icon={faCaretDown} style={{ fontSize: 24 }} />}
                showSearch={true} optionFilterProp="children"
                filterOption={(input, option) =>
                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }>
                    {
                    languages.map((item, index) => {
                        return <Option key={index} value={item}>{item}</Option>
                    })
                    }
                </Select>
              </div>
              </Tooltip>
              <Tooltip placement='left' trigger='hover' title={genre}>
              <div style={{ display: 'flex', flex:1, minHeight: 54, backgroundColor: COLORS.blue2a3a4a, border: '1px solid #1a2a3a', borderTopWidth: 0 }}>
                <div style={{ display: "flex", alignSelf: "center", width: '25%', height:'100%' }}>
                  <h3 style={textStyle}>Genre</h3>
                </div>
                <Select className='multiDropdown' size='large' disabled={disableForm1} 
                  mode="multiple"
                  style={{ width: '75%', fontSize: 14, fontFamily: 'OpenSans-Bold' }}
                  placeholder="Genre"
                  value={this.state.genres}
                  onChange={(e) => { this.setGenre(e) }}
                >
                  {
                    genresList.map((item, index) => {
                        return <Option key={index} value={item}>{item}</Option>
                    })
                  }
                </Select>
              </div>
              </Tooltip>
              <Tooltip placement='left' trigger='hover' title={summaryTooltip}>
              <div style={{ display: 'flex', flex:1, minHeight: 54, backgroundColor: COLORS.blue2a3a4a, border: '1px solid #1a2a3a', borderTopWidth: 0 }}>
                <div style={{ display: "flex", alignSelf: "center", width: '25%', height:'100%' }}>
                  <h3 style={textStyle}>Summary</h3>
                </div>
                <TextArea disabled={disableForm1} placeholder="Summary (500 Characters)" rows={4} autoSize={false} style={{ width: '75%', fontFamily: 'OpenSans-Bold' }} 
                  className='bankInput' value={summary} onChange={(e) => { this.handleSummary(e) }} />
              </div>
              </Tooltip>
              <Tooltip placement='left' trigger='hover' title={ratingTooltip}>
              <div style={{ display: 'flex', flex:1, height: 54, backgroundColor: COLORS.blue2a3a4a, border: '1px solid #1a2a3a', borderTopWidth: 0 }}>
                <div style={{ display: "flex", alignItems: "center", width: '25%', height:'100%' }}>
                  <h3 style={textStyle}>Rating</h3>
                </div>
                <div style={{ display: "flex", justifyContent:'center', backgroundColor: disableForm1 ? COLORS.eeeWhite : COLORS.white,
                alignItems: "center", width: '75%', height:'100%' }}>
                  <Radio.Group disabled={disableForm1} size='middle' value={this.state.rating} buttonStyle="solid" 
                  onChange={(e) => { this.handleRating(e) }} >
                    <Radio.Button value="0+">0+</Radio.Button>
                    <Radio.Button value="7+">7+</Radio.Button>
                    <Radio.Button value="13+">13+</Radio.Button>
                    <Radio.Button value="18+">18+</Radio.Button>
                  </Radio.Group>
                </div>
              </div>
              </Tooltip>
              { isIndia &&
                <Tooltip placement='left' trigger='hover' title={censor}>
                <div style={{ display: 'flex', flex:1, height: 54, backgroundColor: COLORS.blue2a3a4a, border: '1px solid #1a2a3a', borderTopWidth: 0 }}>
                  <div style={{ display: "flex", alignItems: "center", width: '25%', height:'100%' }}>
                    <h3 style={textStyle}>Censor Certificate</h3>
                  </div>
                  <Row align='middle' style={{ width: '75%', backgroundColor: COLORS.eeeWhite }}>
                    <Col span={24}>
                      <Input disabled={disableForm1} value={censorName} onChange={(e) => { this.handleCensorName(e) }}
                        placeholder="Upload Censor Certificate (Optional)" suffix={this.suffixDoc(1)}
                        style={{ height: 53, color: COLORS.blue3a4a5a, fontSize: 14, fontFamily: 'OpenSans-Bold' }} />
                    </Col>
                  </Row>
                  <div style={{ cursor: 'pointer', position: 'absolute', right: -150, height: 54 }}>
                    <div style={{ display: 'flex', justifyContent:'center', alignItems:'center', height: 54 }}>
                      <h3 style={{ color: COLORS.redClose, fontSize: 14, fontFamily: 'OpenSans-Bold', marginBottom: 0, marginLeft: 8 }}>
                          { this.state.deleteIndex===1 ? 'Click again to delete!' : '' }
                      </h3>
                    </div>
                  </div>
                </div>
                </Tooltip>
              }  
            </div>
            <div>
            <div style={{ display: 'flex', justifyContent:'center', marginTop: 12 }}>
                <h5 className="Agree" style={{ fontSize: 14, textAlign:'left', alignSelf:'center', margin: 0, color: COLORS.redClose, fontFamily:'OpenSans-Bold' }}>
                {disableWarnig ? warningText1 : ''}
                </h5>
            </div>
            <div style={{ marginTop: 24, border: '2px solid #1a2a3a'  }}>
              <div style={{ display: 'flex', flex:1, height: 54, backgroundColor: COLORS.yellow, borderBottom: '2px solid #1a2a3a' }}>
                <div style={{ display: "flex", flex:1, justifyContent:'center', alignItems: "center", width: '100%', height:'100%' }}>
                  <FontAwesomeIcon color={COLORS.darkBlue} icon={faUserAstronaut} style={{ fontSize: 24, margin: '12px' }} />
                  <h2 style={{ fontSize: 18, fontFamily: 'OpenSans-Bold', alignSelf:'center', textAlign:'center', color: COLORS.darkBlue, marginBottom: 0 }}>Cast & Crew</h2>
                  <FontAwesomeIcon color={COLORS.darkBlue} icon={faUserAstronaut} style={{ fontSize: 24, margin: '12px' }} />                  
                </div>
                <Button onClick={() => { this.saveMovie2(disableForm2, save2Enabled) }} className='caption' style={{ position:'absolute', display: "flex", alignItems: "center", 
                justifyContent:'center', right: 0, width: 100, height: 32, background: save2BG, borderRadius: 3, margin: 10, opacity: opacity2 }}>
                  <div style={{ display: "flex", alignItems: "center", justifyContent:'center' }}>
                    { this.state.saving2
                    ?
                    <Spin size='small' style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginRight: 12 }} />
                    :
                    <FontAwesomeIcon color={COLORS.darkBlue} icon={faSave} style={{ color: save1Color, fontSize: 14, marginRight: 12 }} />
                    }
                    <h4 style={{ display: "flex", alignItems: "center", color: save1Color, fontSize: 14, height:'100%', margin:0, fontFamily: 'OpenSans-Bold' }}>
                      Save
                    </h4>
                  </div>
                </Button>
              </div>             
              <div style={{ display: 'flex', flex:1, height: 54, backgroundColor: COLORS.blue2a3a4a, border: '1px solid #1a2a3a', borderTopWidth: 0 }}>
                <div style={{ display: "flex", alignItems: "center", width: '25%', height:'100%' }}>
                  <h3 style={textStyle}>Director</h3>
                </div>
                <Input disabled={disableForm2} value={directors} onChange={(e) => { this.handleDirector(e) }}
                  className='bankInput' placeholder="Director" style={inputStyle} />
              </div>
              <div style={{ display: 'flex', flex:1, height: 54, backgroundColor: COLORS.blue2a3a4a, border: '1px solid #1a2a3a', borderTopWidth: 0 }}>
                <div style={{ display: "flex", alignItems: "center", width: '25%', height:'100%' }}>
                  <h3 style={textStyle}>Writer(s)</h3>
                </div>
                <Input disabled={disableForm2} value={writers} onChange={(e) => { this.handleWriter(e) }}
                  className='bankInput' placeholder="Writer(s)" style={inputStyle} />
              </div>
              <div style={{ display: 'flex', flex:1, height: 54, backgroundColor: COLORS.blue2a3a4a, border: '1px solid #1a2a3a', borderTopWidth: 0 }}>
                <div style={{ display: "flex", alignItems: "center", width: '25%', height:'100%' }}>
                  <h3 style={textStyle}>Producer(s)</h3>
                </div>
                <Input disabled={disableForm2} value={producers} onChange={(e) => { this.handleProducer(e) }}
                  className='bankInput' placeholder="Producer(s)" style={inputStyle} />
              </div>
              <div style={{ display: 'flex', flex:1, height: 54, backgroundColor: COLORS.blue2a3a4a, border: '1px solid #1a2a3a', borderTopWidth: 0 }}>
                <div style={{ display: "flex", alignItems: "center", width: '25%', height:'100%' }}>
                  <h3 style={textStyle}>Production House</h3>
                </div>
                <Input disabled={disableForm2} value={productionhouse} onChange={(e) => { this.handleProductionHouse(e) }}
                  className='bankInput' placeholder="Production House" style={inputStyle} />
              </div>
              <div style={{ display: 'flex', flex:1, height: 54, backgroundColor: COLORS.blue2a3a4a, border: '1px solid #1a2a3a', borderTopWidth: 0 }}>
                <div style={{ display: "flex", alignItems: "center", width: '25%', height:'100%' }}>
                  <h3 style={textStyle}>Stars</h3>
                </div>
                <Input disabled={disableForm2} value={stars} onChange={(e) => { this.handleStars(e) }}
                  className='bankInput' placeholder="Hero, Heroine, Support-1, Support-2, etc." style={inputStyle} />
              </div>
            </div>
            <div style={{ marginTop: 40 }}>
                <div className='uploadBox' onClick={() => { disableForm2 ? console.log('for disabled') : this.inputElement1.click() }} 
                style={{ cursor: disableForm2 ? 'no-drop' : 'pointer', height: bannerHeight, display: 'flex', justifyContent:'center', alignContent: 'center' }}>
                  { this.state.bannerImage
                  ?
                  <img id="blah" src={this.state.bannerImage} alt="your pic" style={{ width: '100%' }} />
                  :
                    <div style={{ display: 'table-cell', alignSelf:'center' }}>
                      <p style={{ marginBottom: 0 }} className="ant-upload-drag-icon">
                      <FontAwesomeIcon color={COLORS.greyaaa} icon={faCameraRetro} style={{ fontSize: 40, margin: '12px' }} />
                      </p>
                      <p style={{ color: COLORS.greyaaa, marginBottom: 0 }} className="ant-upload-hint">Upload Wide Banner Image</p>
                      <p style={uploadHintStyle} className="ant-upload-hint">
                      3:1 Aspect Ratio
                      </p>
                      <p style={uploadHintStyle} className="ant-upload-hint">
                      Atleast 3000 x 1000
                      </p>
                      <p style={uploadHintStyle} className="ant-upload-hint">
                      Max 3MB
                      </p>
                      <p style={{ color: COLORS.redClose, fontSize: 14, height: 40, marginBottom: 0 }} className="ant-upload-hint">
                      { this.state.bannerError ? 'Image criteria MUST be as above.' : '' }
                      </p>
                    </div>
                  }
                </div>
                <input style={{ display:'none' }} type="file" ref={input => this.inputElement1 = input} onChange={(e) => { this.onDocUpload(e, 1) }} />   
            </div>
            <div style={{ marginTop: 40, width: '100%' }}>
            <div style={{ display:'flex', justifyContent:'center', alignItems:'center' }}>
                <div className='uploadBox' onClick={() => { disableForm2 ? console.log('for disabled') : this.inputElement2.click() }} 
                style={{ cursor: disableForm2 ? 'no-drop' : 'pointer', width: 5*bannerHeight/3, height: bannerHeight, display: 'flex', justifyContent:'center', alignContent: 'center' }}>
                  { this.state.portraitImage
                  ?
                  <img id="blah" src={this.state.portraitImage} alt="your pic" style={{ width: '100%' }} />
                  :
                  <div style={{ display: 'table-cell', alignSelf:'center' }}>
                    <p style={{ color: COLORS.greyaaa, marginBottom: 0 }} className="ant-upload-drag-icon">
                    <FontAwesomeIcon color={COLORS.greyaaa} icon={faCameraRetro} style={{ fontSize: 40, margin: '12px' }} />
                    </p>
                    <p style={{ color: COLORS.greyaaa, marginBottom: 0 }} className="ant-upload-hint">Upload Second Image</p>
                    <p style={uploadHintStyle} className="ant-upload-hint">
                    5:3 Aspect Ratio
                    </p>
                    <p style={uploadHintStyle} className="ant-upload-hint">
                    Atleast 1500 x 900
                    </p>
                    <p style={uploadHintStyle} className="ant-upload-hint">
                    Max 3MB
                    </p>
                    <p style={{ color: COLORS.redClose, fontSize: 14, height: 40, marginBottom: 0 }} className="ant-upload-hint">
                    { this.state.portraitError ? 'Image criteria MUST be as above.' : '' }
                    </p>
                  </div>
                  }
                </div>
                <input style={{ display:'none' }} type="file" ref={input => this.inputElement2 = input} onChange={(e) => { this.onDocUpload(e, 2) }} />   
                </div>
            </div>

            <Row style={{ height: 400, marginTop: 40 }}>
              <Col span={24} >
                <div className='uploadBox' onClick={()=> { this.openDropBox(disableForm2) }}
                style={{ cursor: disableForm2 ? 'no-drop' : 'pointer', height: 400, display: "flex", justifyContent:'center', alignItems:'center' }} >
                  <div style={{ display: 'table-cell', margin: 30 }}>
                    <div>
                      <p style={{ color: COLORS.greyaaa, marginBottom: 0 }} className="ant-upload-drag-icon">
                        <FontAwesomeIcon color={'#0161ff'} icon={faUpload} style={{ fontSize: 40, margin: '12px' }} />
                      </p>
                    </div>
                    <p style={{ color: COLORS.greyaaa, fontSize: 14 }} className="ant-upload-hint">
                    Hit.Movie requires your Digital Assets in the Interoperable Master Format (<a target='_blank' rel='noopener noreferrer' href="https://www.avid.com/resource-center/what-is-the-interoperable-master-format">IMF</a>).
                    </p>
                    <p style={{ color: COLORS.greyaaa, fontSize: 14 }} className="ant-upload-hint">
                    You can upload your Digital Assets here or send us a link where we can access them. Assets must be at their highest quality and resolution.
                    </p>
                    <p style={{ color: COLORS.greyaaa, fontSize: 14 }} className="ant-upload-hint">
                    Finer specifications can be found <a target='_blank' rel='noopener noreferrer' href="https://docs.hit.movie/das">here</a>.
                    </p>
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                      <Button className='caption' 
                      style={{ display: "flex", alignItems: "center", cursor: disableForm2 ? 'no-drop' : 'pointer', 
                      justifyContent:'center', width: 220, height: 50, background: '#0161ff', borderRadius: 3, margin: 10, opacity: 1 }}>
                        <div style={{ display: "flex", alignItems: "center", justifyContent:'center' }}>
                          <FontAwesomeIcon color={COLORS.white} icon={faUpload} style={{ fontSize: 16, margin: '12px' }} />
                          <h4 style={{ display: "flex", alignItems: "center", color: save1Color, fontSize: 16, height:'100%', margin:0, fontFamily: 'OpenSans-Bold' }}>
                            Click to Upload
                          </h4>
                        </div>
                      </Button>
                    </div>
                  </div>                                        
                </div>
              </Col>
            </Row>
            {/* {this.state.azureTrailerLocatorName
            ?
            <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
              <div style={{ width: 244, marginTop: 40, display: 'flex', justifyContent: 'center', background: COLORS.eeeWhite, borderRadius: 5 }}>
              <Row onClick={() => { this.props.openPlayer(this.state.uploadId, this.state.azureTrailerLocatorName, true) }} 
              style={{ width: 240, height: 56, background: COLORS.lightgreen, borderRadius: 3, margin: 2, cursor: 'pointer' }}>
                <div style={{ display: 'flex', alignItems:'center', width: '100%', height: 56, justifyContent:'center' }}>
                  <FontAwesomeIcon color={COLORS.white} icon={faFilm} style={{ fontSize: 24, marginRight: 8 }} />
                  <div className='col' style={{  }}>
                    <p style={{ color: COLORS.white, fontSize: 18, marginBottom: 0, textAlign:'left', fontFamily: 'OpenSans-Bold' }}>Test Your Trailer</p>
                  </div>
                </div>
              </Row>
            </div>
            </div>
              :
              <div />
            }
            {azureStreamingLocatorName
            ?
            <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
            <div style={{ width: 244, marginTop: 32, display: 'flex', justifyContent: 'center', background: COLORS.eeeWhite, borderRadius: 5 }}>
              <Row onClick={() => { this.props.openPlayer(this.state.uploadId, azureStreamingLocatorName, false) }} 
              style={{ width: 240, height: 56, background: COLORS.lightgreen, borderRadius: 3, margin: 2, cursor: 'pointer' }}>
                <div style={{ display: 'flex', alignItems:'center', width: '100%', height: 56, justifyContent:'center' }}>
                  <FontAwesomeIcon color={COLORS.white} icon={faFilm} style={{ fontSize: 24, marginRight: 8 }} />
                  <div className='col' style={{  }}>
                    <p style={{ color: COLORS.white, fontSize: 18, marginBottom: 0, textAlign:'left', fontFamily: 'OpenSans-Bold' }}>Test Your Movie</p>
                  </div>
                </div>
              </Row>
            </div>
            </div>
            :
            <div />
            } */}
            <div style={{ display: 'flex', justifyContent:'center', marginTop: 24 }}>
                <h5 className="Agree" style={{ whiteSpace:'break-spaces', fontSize: 12, textAlign:'center', alignSelf:'center', margin: 0, color: COLORS.redClose, fontFamily:'OpenSans-Bold' }}>
                {enableBuyWatchnow ? '' : (azureStreamingLocatorName ? warningText3 : warningText2)}
                </h5>
            </div>
            <div style={{ marginTop: 24, border: '2px solid #1a2a3a'  }}>
              <div style={{ display: 'flex', flex:1, height: 54, backgroundColor: COLORS.yellow, borderBottom: '2px solid #1a2a3a' }}>
                <div style={{ display: "flex", flex:1, justifyContent:'center', alignItems: "center", width: '100%', height:'100%' }}>
                  <FontAwesomeIcon color={COLORS.darkBlue} icon={faMoneyBillWave} style={{ fontSize: 24, margin: '12px' }} />
                  <h2 style={{ fontSize: 18, fontFamily: 'OpenSans-Bold', alignSelf:'center', textAlign:'center', color: COLORS.darkBlue, marginBottom: 0 }}>
                    Ticket Prices, Release, Distribution
                  </h2>
                  <FontAwesomeIcon color={COLORS.darkBlue} icon={faMoneyBillWave} style={{ fontSize: 24, margin: '12px' }} />                  
                </div>
                <Button onClick={() => { this.saveMovie3(disableForm3, save3Enabled) }} className='caption' style={{ position:'absolute', display: "flex", alignItems: "center", 
                justifyContent:'center', right: 0, width: 100, height: 32, background: save3BG, borderRadius: 3, margin: 10, opacity: opacity3 }}>
                  <div style={{ display: "flex", alignItems: "center", justifyContent:'center' }}>
                    { this.state.saving3
                    ?
                    <Spin size='small' style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginRight: 12 }} />
                    :
                    <FontAwesomeIcon color={COLORS.darkBlue} icon={faSave} style={{ color: save1Color, fontSize: 14, marginRight: 12 }} />
                    }
                    <h4 style={{ display: "flex", alignItems: "center", color: save1Color, fontSize: 14, height:'100%', margin:0, fontFamily: 'OpenSans-Bold' }}>
                      Save
                    </h4>
                  </div>
                </Button>
              </div>
              <Tooltip placement='left' trigger='hover' title={identityTooltip}>
              <div style={{ display: 'flex', flex:1, minHeight: 54, backgroundColor: COLORS.blue2a3a4a, border: '1px solid #1a2a3a', borderTopWidth: 0 }}>
                <div style={{ display: "flex", alignSelf: "center", width: '25%', height:'100%' }}>
                  <h3 style={textStyle}>Who Can Buy</h3>
                </div>
                <div style={{ display: "flex", justifyContent:'center', backgroundColor: disableForm3 ? COLORS.eeeWhite : COLORS.white, alignItems: "center", width: '75%', height:54 }}>
                  <Radio.Group options={['Everyone', 'ID Verified Users Only']} onChange={this.onChangeIdentitySwitch} 
                    value={this.state.verifyIdentity ? 'ID Verified Users Only' : 'Everyone'} disabled={isReleaseDisabled} style={{ fontFamily: 'OpenSans-Bold' }} />
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', position:'absolute', justifyContent:'center', alignItems: "center", height: 54, right: -40 }}>
                    <div onClick={() => window.open('https://docs.hit.movie/identity-verification')}>
                    <h4 style={{ fontSize: 12, fontFamily: 'OpenSans-Bold', cursor:'pointer', display: 'flex', alignItems:'center', 
                    color: COLORS.lightgreen, marginBottom: 0, marginRight: 3 }}>
                      <FontAwesomeIcon color={COLORS.yellow} icon={faQuestionCircle} style={{ fontSize: 22 }} />
                    </h4>
                    </div>
                </div>
              </div>
              </Tooltip> 
              <Tooltip placement='left' trigger='hover' title={distribution}>
              <div style={{ display: 'flex', flex:1, minHeight: 54, backgroundColor: COLORS.blue2a3a4a, border: '1px solid #1a2a3a', borderTopWidth: 0 }}>
                <div style={{ display: "flex", alignSelf: "center", width: '25%', height:'100%' }}>
                  <h3 style={textStyle}>Distribution</h3>
                </div>
                <Select size='large' className='multiDropdown' 
                disabled={disableForm3} 
                  mode="multiple"
                  value={currentCountryList}
                  style={{ width: '75%', fontSize: 14, fontFamily: 'OpenSans-Bold' }}
                  placeholder="Countries where this movie can play. Default is 'Worldwide'."
                  onChange={(e) => { this.handleCountries(e) }}
                >
                  {
                    countries.map((item, index) => {
                        return <Option key={index} value={item}>{item}</Option>
                    })
                  }
                </Select>
              </div>
              </Tooltip>
              <Tooltip placement='left' trigger='hover' title={exDistribution}>
              <div style={{ display: 'flex', flex:1, minHeight: 54, backgroundColor: COLORS.blue2a3a4a, border: '1px solid #1a2a3a', borderTopWidth: 0 }}>
                <div style={{ display: "flex", alignSelf: "center", width: '25%', height:'100%' }}>
                  <h3 style={textStyle}>Exception</h3>
                </div>
                <Select size='large' className='multiDropdown' 
                disabled={disableForm3||notWorldWide} 
                  mode="multiple"
                  value={this.state.excludedCountries}
                  style={{ width: '75%', fontSize: 14, fontFamily: 'OpenSans-Bold' }}
                  placeholder="Countries where this movie can't play."
                  onChange={(e) => { this.handleExcludeCountries(e) }}
                >
                  {
                    exceptionCountries.map((item, index) => {
                        return <Option key={index} value={item}>{item}</Option>
                    })
                  }
                </Select>
              </div>
              </Tooltip>
              <Tooltip placement='left' trigger='hover' title={ticketPrice}>
              <div style={{ display: 'flex', flex:1, height: 54, backgroundColor: COLORS.blue2a3a4a, border: '1px solid #1a2a3a', borderTopWidth: 0 }}>
                <div style={{ display: "flex", alignItems: "center", width: '25%', height:'100%' }}>
                  <h3 style={textStyle}>Ticket Price</h3>
                  <FontAwesomeIcon color={COLORS.lightgreen} icon={faMoneyBillWave} style={{ fontSize: 24, marginLeft: '12px' }} />                  
                </div>
                <Row align='middle' style={{ width: '75%', backgroundColor: COLORS.eeeWhite }}>
                  <Col span={12}>
                    <Input className="localPrice" disabled={disableForm3} placeholder={"Local Price "+localCharge} type='number'
                    style={{ height: 53, color: disableForm3 ? COLORS.greyaaa : COLORS.blue3a4a5a, fontSize: 14, fontFamily: 'OpenSans-Bold', backgroundColor: disableForm3 ? COLORS.eeeWhite : COLORS.white }} 
                    value={this.state.priceINR} onChange={(e) => { this.handlePriceINR(e) }} suffix={this.suffix1(localCurrency)}/>
                  </Col>
                  <Col span={12}>
                    <Input disabled={disableForm3} placeholder={"Rest of World "+worldCharge} type='number'
                    style={{ height: 53, color: disableForm3 ? COLORS.greyaaa : COLORS.blue3a4a5a, fontSize: 14, fontFamily: 'OpenSans-Bold', borderWidth: 0, backgroundColor: disableForm3 ? COLORS.eeeWhite : COLORS.white }} 
                    value={this.state.priceUSD} onChange={(e) => { this.handlePriceUSD(e) }} suffix={suffix2}/>
                  </Col>
                </Row>
                <div style={{ display: 'flex', flexDirection: 'column', position:'absolute', justifyContent:'center', alignItems: "center", height: 54, right: -108 }}>
                    <div onClick={() => window.open('https://docs.google.com/spreadsheets/d/1RP2wQ1LlOKtY1tJlJ8gK6_7QtozxTKm8lDaNkyk1_vo/edit?usp=sharing')}>
                    <h4 style={{ fontSize: 12, fontFamily: 'OpenSans-Bold', cursor:'pointer', display: 'flex', alignItems:'center', color: COLORS.lightgreen, marginBottom: 0, marginRight: 3 }}>Price Calculator</h4>
                    </div>
                    <div onClick={() => window.open('https://docs.google.com/spreadsheets/d/1RP2wQ1LlOKtY1tJlJ8gK6_7QtozxTKm8lDaNkyk1_vo/edit#gid=44832690')}>
                    <h4 style={{ fontSize: 12, fontFamily: 'OpenSans-Bold', cursor:'pointer', display: 'flex', alignItems:'center', color: COLORS.lightgreen, marginBottom: 0 }}>Minimum Prices</h4>
                    </div>
                </div>
              </div>
              </Tooltip>
              <Tooltip placement='left' trigger='hover' title={viewTimeStr}>
              <div style={{ display: 'flex', flex:1, height: 54, backgroundColor: COLORS.blue2a3a4a, border: '1px solid #1a2a3a', borderTopWidth: 0 }}>
                <div style={{ display: "flex", alignItems: "center", width: '25%', height:'100%' }}>
                  <h3 style={textStyle}>View Time (Days)</h3>
                </div>
                <div style={{ display: "flex", justifyContent:'center', backgroundColor: disableForm3 ? COLORS.eeeWhite : COLORS.white,
                alignItems: "center", width: '75%', height:'100%' }}>
                  <Radio.Group disabled={disableForm3} size='middle' buttonStyle="solid" value={this.state.viewTime}
                  onChange={(e) => { this.handleViewTime(e) }} >
                    <Radio.Button value={1}>1</Radio.Button>
                    <Radio.Button value={2}>2</Radio.Button>
                    <Radio.Button value={3}>3</Radio.Button>
                    <Radio.Button value={4}>4</Radio.Button>
                    <Radio.Button value={5}>5</Radio.Button>
                    <Radio.Button value={6}>6</Radio.Button>
                    <Radio.Button value={7}>7</Radio.Button>
                  </Radio.Group>
                </div>
              </div>
              </Tooltip>
              <Tooltip placement='left' trigger='hover' title={viewTimeHoursStr}>
              <div style={{ display: 'flex', flex:1, height: 54, backgroundColor: COLORS.blue2a3a4a, border: '1px solid #1a2a3a', borderTopWidth: 0 }}>
                <div style={{ display: "flex", alignItems: "center", width: '25%', height:'100%' }}>
                  <h3 style={textStyle}>View Time (Hours)</h3>
                </div>
                <div style={{ display: "flex", justifyContent:'center', backgroundColor: disableForm3 ? COLORS.eeeWhite : COLORS.white,
                alignItems: "center", width: '75%', height:'100%' }}>
                  <Radio.Group disabled={disableForm3} size='middle' buttonStyle="solid" value={this.state.movieViewTimeHours}
                  onChange={(e) => { this.handleViewTimeHours(e) }} >
                    <Radio.Button value={1}>1</Radio.Button>
                    <Radio.Button value={2}>2</Radio.Button>
                    <Radio.Button value={3}>3</Radio.Button>
                    <Radio.Button value={4}>4</Radio.Button>
                    <Radio.Button value={5}>5</Radio.Button>
                    <Radio.Button value={6}>6</Radio.Button>
                    <Radio.Button value={7}>7</Radio.Button>
                  </Radio.Group>
                </div>
              </div>
              </Tooltip>
              <Tooltip placement='left' trigger='hover' title={releaseDateString}>
              <div style={{ display: 'flex', flex:1, minHeight: 54, backgroundColor: COLORS.blue2a3a4a, border: '1px solid #1a2a3a', borderTopWidth: 0 }}>
                <div style={{ display: "flex", alignSelf: "center", width: '25%', height:'100%' }}>
                  <h3 style={textStyle}>Release Date</h3>
                </div>
                <Row style={{ display: "flex", justifyContent:'center', backgroundColor: COLORS.eeeWhite, alignItems: "center", width: '75%', height:'100%' }}>
                  <Col span={12}>
                    <DatePicker disabled={isReleaseDisabled} placeholder='Select Date' disabledDate={disabledDate}
                    value={ this.state.releaseDate ? moment(this.state.releaseDate) : null } showNow={false}
                    format={dateTimeFormat} onChange={(date, string) => { this.onDateChange(date, string) }} 
                    showTime
                    style={{ height: 54, width: '100%', fontSize: 16, color: (isReleaseDisabled) ? COLORS.greyaaa : '#b8b8b8', borderWidth: 0, 
                    backgroundColor: (isReleaseDisabled) ? COLORS.eeeWhite : COLORS.white, fontFamily: 'OpenSans-Bold', borderRightWidth: 1, borderColor: '#000' }} />
                  </Col>
                  <Col span={12}>
                    <Select className='timeZone' disabled={isReleaseDisabled} placeholder='Time Zone' value={timezone}
                    style={{ flex:1, width:'100%', height: 54 }} suffixIcon={<FontAwesomeIcon color={COLORS.yellow} icon={faCaretDown} style={{ fontSize: 24 }} />}
                    onChange={(val)=>{ this.setTimeZone(val) }} showSearch={true} optionFilterProp="children"
                    filterOption={(input, option) =>
                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }>
                        {
                        timezones.map((item, index) => {
                            return <Option key={index} value={item}>{item}</Option>
                        })
                        }
                    </Select>
                  </Col>
                </Row>
              </div>
              </Tooltip>
              <Tooltip placement='left' trigger='hover' title={preBooking}>
              <div style={{ display: 'flex', flex:1, minHeight: 54, backgroundColor: COLORS.blue2a3a4a, border: '1px solid #1a2a3a', borderTopWidth: 0 }}>
                <div style={{ display: "flex", alignSelf: "center", width: '25%', height:'100%' }}>
                  <h3 style={textStyle}>Pre-Booking</h3>
                </div>
                <div style={{ display: "flex", justifyContent:'center', backgroundColor: isReleaseDisabled ? COLORS.eeeWhite : COLORS.white, alignItems: "center", width: '75%', height:54 }}>
                  <Switch checked={this.state.prebooking} disabled={isPrebookingDisabled} style={{ alignSelf:'center', color: COLORS.lightgreen }} 
                    onChange={this.onChangeSwitch} 
                  />
                  <h3 style={{ margin: 0, marginLeft: 20, fontSize: 14, color: isReleaseDisabled ? COLORS.greyaaa : COLORS.blue5a6a7a, fontFamily: 'OpenSans-Bold' }}>
                    Accept Pre-Bookings
                  </h3>
                </div>
              </div>
              </Tooltip>         
            </div>
            <div style={{ position: 'absolute', display: 'flex', justifyContent:'center', marginTop: 12, width: '100%' }}>
                <h5 className="Agree" style={{ whiteSpace:'break-spaces', width: '100%', fontSize: 12, textAlign:'center', alignSelf:'center', margin: 0, color: COLORS.redClose, fontFamily:'OpenSans-Bold' }}>
                {this.state.errorText}
                </h5>
            </div>
            <div style={{ display: "flex", justifyContent:'center', marginTop: 60 }}>
              <h5 className="Agree" style={{ fontSize: 12, textAlign:'left', alignSelf:'center', margin: 0, color: COLORS.redClose, fontFamily:'OpenSans-Bold' }}>
              {supportEmail}
              </h5>
            </div> 
            <div style={{ display: 'flex', width: '100%', justifyContent:'center', marginTop: 12 }}>
                <FontAwesomeIcon color={COLORS.blue3a4a5a} icon={faWater} style={{ fontSize: 36, margin: 36 }} />
            </div>
        </div>
        </div>
    );
  }
}
